import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Translation } from "react-i18next";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { ActionCreators as UndoActionCreators } from 'redux-undo'
import Emitter from "_actions/emitter";
import i18n from "i18n";
import { ResponseStatusCode } from "_helpers";
import { addNewPage, removeComponent } from '_actions'
import { pagesService,GetConsoleFrontEnd } from "_services";
import { Alert } from 'rsuite';

import ProjectCard from 'components/Projects/ProjectCard';

import {
    Button,
    Input,
    Modal,
    Container,
    Row, Col
} from "reactstrap";

class SelectProject extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
        }
    }

    handleGoToConsole = () => {
        /*
        Alert.warning("Consol'a gitmeli")
        */
 
        //  window.open(prapareLink,"_blank");
        window.location.href=GetConsoleFrontEnd();
    }
    handleClose = () => {
        const { handleToggle } = this.props;
        handleToggle();
    }
    render() {
        const { isActive, handleToggle, projectList,isChangeProject } = this.props;
        const lastUpdateList = projectList ? (projectList.dynamicValue.sort((a, b) => new Date(b.setting.lastSave) - new Date(a.setting.lastSave))) : [];

        return (
            <Translation>
                {t => (
                    <>
                        <Modal
                            className={"modal-dialog-centered"+" httpobject-modal"}
                            isOpen={isActive}
                            size="lg"
                           // scrollable={true}
                        >
                            <div className="modal-header">
                                <h5 className="modal-title" id="CheckProjectModal">
                                    {t("MODAL_TITLE_SELECT_PROJECT")}
                                </h5>
                                {
                                    isChangeProject &&
                                    <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => handleToggle()}
                                >
                                    <span aria-hidden={true}>×</span>
                                </button>
                                }
                            </div>
                            <div className="modal-body">
                                    <Row>
                                        {
                                            projectList &&
                                            lastUpdateList &&
                                            lastUpdateList.map((item, key) => (
                                                <Col xs="6" sm="3" lg="2" key={key} className={"project-col"}>
                                                    <ProjectCard isChangeProject={true} isBussy={this.state.loading} data={item} handleClose={this.handleClose} />
                                                </Col>
                                            ))
                                        }
                                        {

                                            (!projectList || projectList.dynamicValue.length < 1) &&
                                            <Col>
                                                <p className={"faq-no-result-found"}>
                                                    {t("PROJECTS_NO_RESULT")}
                                                </p>
                                            </Col>

                                        }
                                    </Row>

                             </div>
                            <div className="modal-footer">
                                {
                                    /*
                                      <Button
                                        color="white"
                                        size={"sm"}
                                        data-dismiss="modal"
                                        disabled={this.state.loading}
                                        type="button"
                                        onClick={() => handleToggle()}
                                    >
                                        {t("MODAL_CREATE_NEWPAGE_BUTTON_CANCEL")}
                                    </Button>
                                    */
                                }
                                <Button color="primary" size={"sm"} type="button" onClick={() => this.handleGoToConsole()}>
                                    {t("MODAL_SELECT_PROJECT_BUTTON_OPEN_CONSOLE")}
                                </Button>
                            </div>
                        </Modal>

                    </>

                )}
            </Translation>
        )
    }
}

const mapStateToProps = (state, props) => {
    const { componentReducer, editorReducer, currentstatesReducer } = state;
    const { currentProjectId } = currentstatesReducer;

    const { component } = componentReducer;

    return {
        component,
        currentProjectId
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearHistory: () => dispatch(UndoActionCreators.clearHistory()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SelectProject)
